module.exports = __webpack_public_path__ + "img/BusinessInsurance.d60a7044.webp";